import React from "react";
import PropTypes from "prop-types";
import { Card, Layout, SkeletonBodyText, SkeletonDisplayText, TextContainer } from "@shopify/polaris";

const SkeletonAnnotatedCard = (props) => {
  const { annotatedLines = 3, primaryLines = 4 } = props;
  return (
    <>
      <Layout.AnnotatedSection
        title={<SkeletonDisplayText size="small" />}
        description={<SkeletonBodyText lines={annotatedLines} />}
      >
        <Card sectioned>
          <TextContainer>
            <SkeletonBodyText lines={primaryLines} />
          </TextContainer>
        </Card>
        <Card sectioned>
          <TextContainer>
            <SkeletonBodyText lines={primaryLines} />
          </TextContainer>
        </Card>
        <Card sectioned>
          <TextContainer>
            <SkeletonBodyText lines={primaryLines} />
          </TextContainer>
        </Card>
        <Card sectioned>
          <TextContainer>
            <SkeletonBodyText lines={primaryLines} />
          </TextContainer>
        </Card>
        <Card sectioned>
          <TextContainer>
            <SkeletonBodyText lines={primaryLines} />
          </TextContainer>
        </Card>
      </Layout.AnnotatedSection>
    </>
  );
};

SkeletonAnnotatedCard.propTypes = {
  annotatedLines: PropTypes.number,
  primaryLines: PropTypes.number,
};

SkeletonAnnotatedCard.defaultProps = {
  annotatedLines: 3,
  primaryLines: 2,
};

export default SkeletonAnnotatedCard;
